// Mapeamento (número da linha -> GTFS route_id)
// Fonte: FRONTEND_DIRECTIONS.md
export const GTFS_ROUTE_ID_BY_SHORT_NAME = Object.freeze({
  "2101": "25775",
  "2102": "25914",
  "2103": "25778",
  "2105": "25780",
  "2106": "25781",
  "2107": "25782",
  "2108": "25776",
  "2109": "25777",
  "2110": "25783",
});

const GTFS_ROUTE_ID_VALUES = new Set(Object.values(GTFS_ROUTE_ID_BY_SHORT_NAME));

export const resolveGtfsRouteId = (routeIdOrShortName) => {
  if (routeIdOrShortName === undefined || routeIdOrShortName === null) {
    return null;
  }

  const raw = String(routeIdOrShortName).trim();
  if (raw === "") return null;

  // Se vier o número da linha (ex.: 2101), traduz para GTFS route_id
  const mapped = GTFS_ROUTE_ID_BY_SHORT_NAME[raw];
  if (mapped) return mapped;

  // Se já vier o GTFS route_id (ex.: 25775), retorna como está
  if (GTFS_ROUTE_ID_VALUES.has(raw)) {
    return raw;
  }

  // Fallback: mantém o valor original (p/ não quebrar linhas fora do hardcode)
  return raw;
};
